<div class="top">
	<a class="back-button" mat-button routerLink="../pre-visit">
		<mat-icon [inline]="true">chevron_left</mat-icon>
		<div>Back to encounter</div>
	</a>

	<h1>Select note template</h1>

	<mat-divider></mat-divider>
</div>

<div class="templates">
	@if (templates) {
		<mat-selection-list [(ngModel)]="selectedTemplate" [multiple]="false" [hideSingleSelectionIndicator]="true">
			@for (template of templates; track template.id) {
				<mat-list-option [value]="template">{{ template.name }}</mat-list-option>
			}
		</mat-selection-list>
	}
</div>

<app-bottom-buttons>
	<button class="big-blue-button" mat-ripple [disabled]="selectedTemplate == null" (preventDoubleClick)="applyTemplate()">
		Apply
	</button>
</app-bottom-buttons>
